import { useEffect, useRef, useState } from "react";

export default function Reveal({ children, direction = "up", delay = 0, className = "" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setShown(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { setShown(true); io.unobserve(e.target); }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
  const dist = isMobile ? 16 : 44;
  const initial =
    direction === "left" ? `translateX(-${dist}px)` :
    direction === "right" ? `translateX(${dist}px)` :
    `translateY(${isMobile ? 12 : 22}px)`;

  const style = {
    transition: "opacity 700ms ease, transform 700ms ease",
    transitionDelay: `${delay}ms`,
    opacity: shown ? 1 : 0,
    transform: shown ? "none" : initial,
    willChange: "opacity, transform",
  };

  return <div ref={ref} style={style} className={className}>{children}</div>;
}
